import * as S from './styles';
import { useBackNavigation } from '@/shared';
import { SearchInput } from '@/components';
import { useCart, useGlobals, useClient } from '@/hooks';
import { LinkProps as Props } from '@/types';
import * as R from '@/constants/systemRoutes';
import { RiArrowLeftLine } from 'react-icons/ri';
import { useCallback, useEffect, useMemo } from 'react';
import { useParams, useLocation, UNSAFE_useRouteId, useSearchParams, useNavigate } from 'react-router-dom';

interface PropsChild {
  rightIcon?: any;
  stickChild?: any;
  routeLabelSize?: number;
}

const Header = ({ rightIcon, stickChild, routeLabelSize }: PropsChild) => {
  const { goBack } = useBackNavigation();

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const routeID = UNSAFE_useRouteId();

  const params = Object.entries(useParams());
  const { routeTitle, fatherRouteTitle, setRouteTitle, setFatherRouteTitle } = useGlobals();
  const { isSearching, setFilterTerm, filterTerm, totalVolume, cartDetails } = useCart();
  const { selectedClient } = useClient();

  const cartItemsCount = cartDetails?.[selectedClient?.COD_CLIENTE]?.items?.length;

  useEffect(() => {
    if (routeID === R.SUBCATEGORIES.id) return;

    setRouteTitle('');
    setFatherRouteTitle('');
  }, [routeID, setRouteTitle, setFatherRouteTitle]);

  const listShowBackTitle = [R.SUBCATEGORIES];
  const listHasDescription = [R.SUBCATEGORIES];
  const listWithoutArrow = [R.LOGIN, R.MAIN, R.SUCCESS];
  const listHandleHookTitle = [R.SUBCATEGORIES, R.CATEGORY, R.INDICATORS];
  const listWithoutRadius = [R.PRODUCTIVITY_EXTRACT, R.SALES_CYCLE, R.SALES_REPORT, R.INDICATORS, R.COMISSION_REPORT, R.MESSAGES];
  const listWithColeredExtension = [R.CATEGORY, R.PRODUCTIVITY_EXTRACT, R.SALES_CYCLE];
  const listWithExtension = [R.LOGIN, R.COMPANY, R.CATEGORY, R.CATEGORIES, R.SUBCATEGORIES, R.CLIENT_ORDER_DETAIL];
  const listToHideHeader = [
    R.MESSAGE,
    R.MAIN,
    R.NO_MATCH,
    R.SEARCH,
    R.ECOMMERCE,
    R.DASHBOARD,
    R.MY_CLIENTS,
    R.PRODUCT_PAGE,
    R.CLIENT_ORDER_PAGE,
    R.NEW_CLIENT,
    R.PERFORMANCE_INDICATORS,
    R.ORDER_STATUS_PAGE,
    R.TITLE_REPORT,
    R.ORDER_REPORT,
    R.RETURN_REPORT,
  ];

  const path = useMemo(() => {
    return params.reduce((acc, [k, v]) => `${acc?.replace(`/${v}`, `/:${k}`)}`, pathname);
  }, [params, pathname]);

  const findRoute = useCallback((list: Props[]) => list?.find((i) => [i.link, ...(i?.match || [])].includes(path)), [path]);

  const currentRouteLabel = useMemo(() => findRoute(Object.values(R))?.title || 'Página não encontrada', [findRoute]);

  const shouldHideForCuttingReport = pathname === R.INDICATORS.link && searchParams.get('tipo') === 'relatorio-corte';

  if ((findRoute(listToHideHeader) || shouldHideForCuttingReport) && !stickChild && !rightIcon) return null;

  const hasRadius = findRoute(listWithoutRadius);
  const hideArrow = findRoute(listWithoutArrow);
  const hasExtension = findRoute(listWithExtension);
  const showBackTitle = findRoute(listShowBackTitle);
  const hasDescription = findRoute(listHasDescription);
  const coloredExtension = findRoute(listWithColeredExtension);
  const shouldShowHookTitle = findRoute(listHandleHookTitle);

  const isSeachable =
    pathname === R.CART.link ||
    pathname === R.CLIENT_ORDER_PAGE.link ||
    pathname === R.ORDER_STATUS_PAGE.link ||
    pathname === R.MY_CLIENTS.link;

  const handleBack = () => {
    if (pathname.startsWith('/modulos')) {
      navigate(R.DASHBOARD.link);
      return;
    }
    goBack();
  };

  const listToIgnoreHideHeader = [R.MY_CLIENTS.link, R.LOGIN.link];
  const className = !listToIgnoreHideHeader.includes(pathname) ? 'scroll-up' : '';

  return (
    <S.Container className={className}>
      <S.HeaderWrapper
        $maxHeight={pathname === '/carrinho' && isSearching}
        $noradius={!!stickChild || !!hasRadius}
        $hasextension={!!hasExtension}
      >
        {isSearching && pathname === '/carrinho' ? (
          <SearchInput
            id={'carrinho'}
            setInput={setFilterTerm}
            value={filterTerm}
            onBlur={() => null}
            name="Busca"
            $animate={isSeachable}
            placeholder="Pesquisar produto no carrinho"
          />
        ) : (
          <S.HeaderWrapperTitle $animate={isSeachable}>
            {!hideArrow ? (
              <S.BackButton onClick={handleBack} data-test="header-component-goback">
                <RiArrowLeftLine size={20} />
                {showBackTitle && shouldShowHookTitle && (routeTitle || fatherRouteTitle) && (
                  <S.RouteSublabel>{fatherRouteTitle || currentRouteLabel}</S.RouteSublabel>
                )}
              </S.BackButton>
            ) : (
              <S.BackButton />
            )}

            <S.RouteLabel $routelabelsize={routeLabelSize}>
              {(shouldShowHookTitle && routeTitle) || currentRouteLabel}

              {cartItemsCount > 0 && pathname === R.CART.link && !isSearching && (
                <small>
                  ({cartItemsCount} {cartItemsCount > 1 ? 'itens' : 'item'}, {totalVolume}{' '}
                  {totalVolume > 1 ? 'volumes' : 'volume'})
                </small>
              )}
            </S.RouteLabel>

            {rightIcon || <S.ActionButton />}
          </S.HeaderWrapperTitle>
        )}
      </S.HeaderWrapper>

      {hasExtension && <S.Extension $bgcolor={!!shouldShowHookTitle} $bgcolor2={!!coloredExtension} />}

      {shouldShowHookTitle && hasDescription && <S.Description>{routeTitle}</S.Description>}

      {stickChild && stickChild}
    </S.Container>
  );
};

export default Header;
